"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bools = void 0;
class Bools {
    /**
     * Determines if a value is strictly a boolean `true` or `false`. Anything else
     * will result in the method returning `false`.
     *
     * Useful in cases where you have an optional boolean parameter that you need
     * to assign a default value to by determining if it had been set or not.
     *
     * @param val The value to be decided on whether it's strictly boolean `true`
     * or `false`.
     */
    static isBooleanStrict(val) {
        return val === true || val === false;
    }
}
exports.Bools = Bools;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYm9vbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvbWFpbi90eXBlc2NyaXB0L2Jvb2xzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLE1BQWEsS0FBSztJQUNoQjs7Ozs7Ozs7O09BU0c7SUFDSSxNQUFNLENBQUMsZUFBZSxDQUFDLEdBQVk7UUFDeEMsT0FBTyxHQUFHLEtBQUssSUFBSSxJQUFJLEdBQUcsS0FBSyxLQUFLLENBQUM7SUFDdkMsQ0FBQztDQUNGO0FBZEQsc0JBY0MifQ==